import { useState } from 'react';

export default function ServicesGrid() {
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);

  const services = [
    {
      icon: 'ri-lightbulb-line',
      title: 'Strategic Planning',
      description: 'Develop comprehensive strategies aligned with your business objectives, market opportunities, and long-term vision for sustainable competitive advantage.',
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Business Advisory',
      description: 'Expert guidance on business operations, market expansion, organizational structure, and decision-making processes to drive growth and profitability.',
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Operations Management',
      description: 'Optimize your operational processes, improve efficiency, reduce costs, and enhance productivity through systematic analysis and implementation.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Risk Management',
      description: 'Identify, assess, and mitigate business risks through comprehensive frameworks, ensuring business continuity and regulatory compliance.',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Change Management',
      description: 'Guide your organization through transformational changes with structured approaches that minimize disruption and maximize adoption.',
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Performance Optimization',
      description: 'Analyze and enhance business performance through KPI tracking, process improvements, and data-driven decision-making frameworks.',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our Consultancy Expertise
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Comprehensive advisory services designed to transform your business operations and drive measurable results
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const isHovered = hoveredCard === index;
            return (
              <div
                key={index}
                onMouseEnter={() => setHoveredCard(index)}
                onMouseLeave={() => setHoveredCard(null)}
                className={`relative p-8 rounded-2xl border-2 overflow-hidden transition-all duration-300 cursor-pointer ${
                  isHovered
                    ? 'bg-gradient-to-br from-teal-500 to-teal-600 border-teal-500 -translate-y-2 shadow-2xl shadow-teal-200'
                    : 'bg-white border-gray-200 hover:border-teal-200 hover:shadow-lg'
                }`}
              >
                {/* 背景光晕 */}
                <div
                  className={`absolute inset-0 rounded-2xl transition-opacity duration-300 ${isHovered ? 'opacity-100' : 'opacity-0'}`}
                  style={{ background: 'radial-gradient(circle at 80% 15%, rgba(255,255,255,0.18) 0%, transparent 60%)' }}
                />

                {/* 图标 */}
                <div className={`w-16 h-16 flex items-center justify-center rounded-xl mb-6 transition-all duration-300 ${
                  isHovered ? 'bg-white/20 scale-110' : 'bg-teal-50 scale-100'
                }`}>
                  <i className={`${service.icon} text-3xl transition-colors duration-300 ${
                    isHovered ? 'text-white' : 'text-teal-600'
                  }`}></i>
                </div>

                <h3 className={`text-xl font-bold mb-4 transition-colors duration-300 ${
                  isHovered ? 'text-white' : 'text-gray-900'
                }`}>
                  {service.title}
                </h3>

                <p className={`leading-relaxed mb-6 transition-colors duration-300 ${
                  isHovered ? 'text-white/90' : 'text-gray-600'
                }`}>
                  {service.description}
                </p>

                {/* Learn More 箭头滑入 */}
                <div className={`inline-flex items-center gap-2 text-sm font-semibold whitespace-nowrap transition-all duration-300 ${
                  isHovered ? 'text-white opacity-100 translate-x-0' : 'text-teal-600 opacity-80 -translate-x-1'
                }`}>
                  Learn More
                  <i className={`ri-arrow-right-line text-base transition-transform duration-300 ${isHovered ? 'translate-x-1' : ''}`}></i>
                </div>

                {/* 底部装饰线 */}
                <div className={`absolute bottom-0 left-0 h-0.5 bg-white/40 transition-all duration-500 ${isHovered ? 'w-full' : 'w-0'}`} />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
